__turbopack_context__.v({
  "empty": "ServicePriceLookup-module-scss-module__Oa_Qeq__empty",
  "error": "ServicePriceLookup-module-scss-module__Oa_Qeq__error",
  "form": "ServicePriceLookup-module-scss-module__Oa_Qeq__form",
  "formActions": "ServicePriceLookup-module-scss-module__Oa_Qeq__formActions",
  "formBlock": "ServicePriceLookup-module-scss-module__Oa_Qeq__formBlock",
  "header": "ServicePriceLookup-module-scss-module__Oa_Qeq__header",
  "hintLink": "ServicePriceLookup-module-scss-module__Oa_Qeq__hintLink",
  "intro": "ServicePriceLookup-module-scss-module__Oa_Qeq__intro",
  "loaderPlaceholder": "ServicePriceLookup-module-scss-module__Oa_Qeq__loaderPlaceholder",
  "results": "ServicePriceLookup-module-scss-module__Oa_Qeq__results",
  "resultsActions": "ServicePriceLookup-module-scss-module__Oa_Qeq__resultsActions",
  "resultsHeading": "ServicePriceLookup-module-scss-module__Oa_Qeq__resultsHeading",
  "root": "ServicePriceLookup-module-scss-module__Oa_Qeq__root",
  "search": "ServicePriceLookup-module-scss-module__Oa_Qeq__search",
  "searchButton": "ServicePriceLookup-module-scss-module__Oa_Qeq__searchButton",
  "tableTitle": "ServicePriceLookup-module-scss-module__Oa_Qeq__tableTitle",
  "title": "ServicePriceLookup-module-scss-module__Oa_Qeq__title",
});
